export default __webpack_public_path__ + "static/media/trip-delay.68afe400.png";